"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.IVType_Factory = exports.Date_Factory = void 0;
var Date_Factory_1 = require("./Date_Factory");
Object.defineProperty(exports, "Date_Factory", { enumerable: true, get: function () { return Date_Factory_1.Date_Factory; } });
var IVType_Factory = /** @class */ (function () {
    function IVType_Factory() {
    }
    IVType_Factory.CreateIncoming = function (model) {
        if (!model)
            return model;
        var result = {
            Code: model.Code,
            Description: model.Description,
        };
        return result;
    };
    IVType_Factory.CreateOutgoing = function (model) {
        if (!model)
            return model;
        var result = {
            Code: model.Code,
            Description: model.Description,
        };
        return result;
    };
    return IVType_Factory;
}());
exports.IVType_Factory = IVType_Factory;
